"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _HBPill = require("./HBPill.styles");
var _HBPill2 = require("./HBPill.types");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBPill = function HBPill(_ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    label = _ref.label,
    className = _ref.className,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _HBPill2.PillType.Draft : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _HBPill2.PillSize.Small : _ref$size,
    _ref$isLowerCase = _ref.isLowerCase,
    isLowerCase = _ref$isLowerCase === void 0 ? false : _ref$isLowerCase,
    icon = _ref.icon,
    onClick = _ref.onClick,
    isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    margin = _ref.margin;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'pill',
    componentName: 'HBPill'
  });
  return /*#__PURE__*/_react["default"].createElement(_HBPill.Pill, {
    className: className,
    onClick: onClick,
    size: size,
    theme: theme,
    $isLowerCase: isLowerCase,
    isDisabled: isDisabled,
    $isLoading: isLoading,
    testId: finalTestId,
    $margin: margin
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon && /*#__PURE__*/_react["default"].createElement(_HBPill.IconWrapper, {
    theme: theme
  }, icon), label));
};
var _default = exports["default"] = HBPill;
//# sourceMappingURL=HBPill.js.map